module.exports = __webpack_public_path__ + "static/media/295446.d7b6ea0e.png";